import { PATHS } from '@client/routes';
import { ButtonLink } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';

export const CollectionTypeModal = ({
  creatorId,
  isOpen,
  onClose,
}: {
  creatorId: number;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const options = selectionOptions(creatorId);
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Select collection type"
      disableBackdropClick={true}
      modalClassName="w-full md:w-[742px]"
    >
      <div className="flex flex-col gap-6">
        <div className="flex gap-2">
          <Typography variant="body" size="large" className="font-normal">
            Collections are a way to package your content by theme or as a plan.
            There are currently two types of collections: Category and Program
          </Typography>
          <a
            href="https://help.playbookapp.io/en/collections/9730965-build-programs-workouts"
            target="_blank"
            rel="noreferrer"
          >
            <Typography
              className={clsx(
                sprinkles({ color: 'P-80' }),
                'w-[80px] text-center',
              )}
            >
              Learn more
            </Typography>
          </a>
        </div>
        <div className="flex flex-col md:flex-row gap-[49px] items-center justify-center">
          {options.map((option) => (
            <div
              key={option.title}
              className={clsx(
                'flex flex-col p-4 gap-3 rounded-[10px] items-center',
                sprinkles({ bg: 'N-10' }),
              )}
            >
              <Typography variant="title">{option.title}</Typography>
              <Typography
                variant="body"
                size="medium"
                className={clsx('font-normal', sprinkles({ color: 'P-80' }))}
              >
                {option.details}
              </Typography>
              <img
                src={
                  import.meta.env.BASE_URL +
                  (option.type === 'category'
                    ? 'static/images/category-group.png'
                    : 'static/images/program-group.png')
                }
                className="max-w-[265px]"
              />
              <ButtonLink
                color="neutral"
                to={option.to}
                className="w-[147px]"
                data-testid={option.testId}
              >
                Select
              </ButtonLink>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

const selectionOptions = (creatorId: number) => [
  {
    title: 'Category',
    details: 'exercises grouped by theme',
    type: 'category',
    to: PATHS.NEW_CATEGORY(creatorId),
    testId: 'subscriptions-onboarding-create-category',
  },
  {
    testId: 'subscriptions-onboarding-create-program',
    title: 'Program',
    details: 'exercises grouped as plan',
    type: 'program',
    to: PATHS.NEW_PROGRAM(creatorId),
  },
];
